import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Services from '../pages/Services';
import Booking from '../pages/Booking';
import Contact from '../pages/Contact';
import NotFound from '../pages/NotFound';
import ServiceDetail from '../pages/ServiceDetail';

const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/services" element={<Services />} />
    <Route path="/services/:slug" element={<ServiceDetail />} />
    <Route path="/booking" element={<Booking />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);
export default Router;
